import axios from "axios";
import { del, get, post, patch,  put } from "./final_decisions_api_helper";
import * as url from "./final_decisions_url_helper";






export const getFinalDecisions = ( session_uuid, study_level_id ) =>get(`${url.GET_FINAL_DECISIONS}/session/${session_uuid}`, {params: { study_level_id }});


export const getRetestCandidates = (session_uuid, study_level_id) => get(`${url.GET_FINAL_DECISIONS}/session/${session_uuid}/retest-candidates`, { params: { study_level_id } });